import React from "react";
// import { Route, Routes } from 'react-router-dom';
// import Home from './/Home';
// import Services from './/Services';
// import Footer from '../Footer/Footer';
// import Events from './/Events';
// import Testimonial from './/Testimonial';
import Image1 from '../Images/rdfs002.jpg';
import './Pages.css';
import Image2 from '../Images/bhup.png';
import Image3 from '../Images/rdfs10.jpg';
import Icon1 from '../Images/ic_youtube-48.png';
import Icon2 from '../Images/ic_facebook-48.png';
import Icon3 from '../Images/ic_instagram-48.png';
import Icon4 from '../Images/ic_twitter-48.png';
import Icon5 from '../Images/ic_whatsapp-48.png';
import '../pages/Shining.css';
import { Link } from 'react-router-dom';
// import Bgd from '../components/Images/rdfs_cover.jpg';
import Navbar from '../Navbar/Navbar';
import { useState } from "react";
// import Testimonial from "./Testimonials";
// import { FaInstagram, FaYoutube } from "react-icons/fa";
// import { FaFacebook } from "react-icons/fa";
// import { FaTwitter } from "react-icons/fa";
import {db} from './Firebase';
import {collection, addDoc} from 'firebase/firestore';
// import {collection, getDocs, addDoc} from 'firebase/firestore';

const Contents = ()=>{
    const [name, setName] = useState('');
    const [address, setAddress] = useState('general@rachnamail.com');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const dbRef = collection(db, "users");
    const [result, setResult] = useState('');



    const saveMessage = async ()=>{
        try{
            await addDoc(dbRef, {name: name, address: address, phone: phone, message: message});
            setResult(`Thankyou dear ${name}! We have recieved your message and will connect with you very soon.`)
            setName('');
            // setAddress('');
            setPhone('');
            setMessage('');
        } catch(err){
            setResult('Error: ' + err);
        }
    }
    
    return(
        <>
        <section id="hero">
            <div className="hero container">
                <div style={{position: 'fixed', height: '56px'}}>
                    <header style={{height: '56px'}}>
                    <Navbar />
                    </header>
                </div>
                <div>
                    <h1 className="shining-text">रचना डिज़ी फिल्म्स</h1>
                    <Link to="/portfolio" type="button" className="cta">Portfolio</Link>                    
                </div>
            </div>
        </section>
        {/* <div className="divsep"></div> */}
        <section id="services">
                <div className="services container">
                    <div className="service-top">
                            <h1 className="section-title">Services</h1>
                            <p>We are a well experienced and professional team.</p>
                            <p>Your satisfaction is our goal.</p>
                            <li>"We don't want to push our ideas on to customers, we simply want to make what they want."</li>
                            <li>A measurement that determines how happy customers are with a company's products, services, and capabilities.</li>
                    </div>
                    <div className="service-bottom">
                        <div className="service-item">
                            <h2>Pre Wedding Shooting</h2>
                            <p><code>Why do couple shoot?</code> When you opt for a couple shoots, you get to sneak away from the everyday monotony of life, and just be with each other, and spend the much needed time.</p>
                            <p>Pre-wedding photography allows both partners to get to know each other better. You are free to pose or not to pose. Pre-wedding shoot photographers are intent on capturing natural moments, expressions, and real emotions shared by the couple. Such pictures make your album more vibrant.</p>
                            <p>A pre-wedding shoot is a perfect way to capture your love for each other without any cousins or musketeers around. It makes graet filmland which you can latterly frame and keep your beside or on your work office toremember the magical time leading up to your marriage.</p>
                            <p>Pre-wedding shoot isn't just taking photos of the couple. It's about telling your story, no matter long or short, in a manner that you're most comfortable with.</p>
                        </div>
                        <div className="service-item">
                            <h2>Wedding Shooting</h2>
                            <p><code>photos are the lifelong asset for any event.</code> Wedding photography is a specialty that is primarily focused on the events and activities relating to weddings. One of the stylish marriage shutterbugs in India has been landing joyful moments for further than a decade. A marriage day is a veritably special day in one's life, be it a small intimate, a big fat marriage event, or a destination marriage. This is the day when feelings will run high and will form new connections. On this special day, you need a platoon of stylish marriage shutterbugs who have an eye for detail and who won't miss any of the marriage moments.</p>
                            <p><code>Candid Photography</code> Whether it's pure, unalloyed joy or gashes of sadness, a candid shooter can capture these feelings in a manner no one differently can</p>
                            <p><code>Destination Wedding</code> Currently, utmost couples are concluding for fantastic lacales and destinations for hosting their marriage observances as they make your marriage moments more beautiful.</p>
                        </div>
                        <div className="service-item">
                            <h2>Short Films</h2>
                            <p>This is amazing considering most of the world’s filmmakers began out by making short films. Household names such as David Lynch and Christopher Nolan are just two examples of filmmakers who started out making short films.</p>
                            <p><code>Why Short Films Need Our Support & Short Film Importance?</code> Given their obvious importance to the industry, why do short films still remain so much in the shadows? In this article, we set out to show why short films are so important and why short films need our support?</p>
                            <p><code>What are short films?</code> Before attempting to highlight why short films are so important, it would probably be a good idea to define what a short film actually is. A short film is typically considered to be a movie that is less than 30 minutes in length. Some Short film festivals do accept longer movies. But generally speaking, 30 minutes in length is considered the industry standard.</p>
                        </div>
                    </div>
                </div>
        </section>
        <section id="projects">
            <div className="projects container">
                <div className="projects-header">
                    <h1 className="section-title">Upcoming Short-Films</h1>
                </div>
                <div className="all-projects">
                       <div className="project-item">
                            <div className="project-info">
                                <h1>तू मुझमें कहीं वाकी है</h1>
                                <h1>[Tu Mujh mein Kahin Waaki Hai]</h1>
                                <h2>Coding is love</h2>
                        
                                <div className="project-img">
                                    <div style={{width: '100%', marginBottom: '10px'}}>
                                    <h5> Producer: Rachna Digi Films</h5>
                                    <h5> Genre : EMOTIONAL</h5>
                                    </div>
                                    <img src={Image1} alt="proj" style={{float: 'right'}}/> 
                                                                     
                                    <p>तू मुझमें कहीं वाकी है एक भावनात्मक प्रेम कहानी है। आत्मिक प्रेम की पराकाष्ठा, जहाँ एक मुस्लिम लड़की एक विशुद्ध और सात्विक हिंदू लड़के के प्रेम में नमाज़ के साथ साथ भगवान श्रीकृष्ण और भगवान श्री राम को भी अपना आरध्य मानती है वहीं उस हिंदू लड़के की आत्मा अपने प्रेम के बिना अधूरी भटकती है।</p>
                                    <p>गरुण पुराण के चित्रण से सुशोभित अपनी कहानी और फिल्म की पटकथा को भूपेंद्र विश्नोई निर्देशित करेंगे।</p>
                                    <p>सुजीत चौधरी फिल्म को संगीत से सजा रहे हैं। गोविंदा बजाज, बर्षा पाल, अक्षय, अक्षित विश्नोई, राजीव, आकाश और ममता चौधरी अपने अभिनय से इस फिल्म को संवारेंगे। फिल्म की शूटिंग हरिद्वार, ऋषिकेश, रामनगर और मुरादाबाद में शुरु होगी।</p>
                                    <h4>Story & Screen-play: Bhupendra Vishnoi.</h4>
                                </div>
                            </div>
                        </div>

                        <div className="project-item">
                            <div className="project-info">
                                <h1>जॉनाकी [Jonaaki]</h1>
                                <h2>It is a unique story in itself.</h2>
                        
                                <div className="project-img">
                                    <div style={{width: '100%', textAlign: 'right', marginBottom: '10px'}}>
                                    <h5> Producer: Rachna Digi Films</h5>
                                    <h5> Genre : EMOTIONAL</h5>
                                    </div>
                                    <img src={Image3} alt="proj" style={{float: 'left'}}/>
                                    <p>इस फिल्म की कहानी में हमने एक गुड़िया के जीवन को चित्रित किया है जिसने जीवन के रंगों को जीवंत कर दिया। यह फिल्म एक गुड़िया और अपने एकल और एकांत जीवन को जीने वाले एक अत्यंत भावुक व्यक्ति के बीच प्रेम को प्रदर्शित करती है।</p>
                                    <p>कहानी और पटकथा के साथ साथ फिल्म के निर्देशन से भूपेंद्र विश्नोई अपनी कल्पना को छोटे पर्दे पर उतारने के लिये आतुर है। फिल्म की शूटिंग बहुत जल्दी शुरू होगी।</p>
                                    <p>फिल्म में संगीत सुजीत चौधरी दे रहे हैं। गोविंदा बजाज, आकाश, सोनाली, अमित, राजीव और गुड़िया जॉनाकी इस फिल्म को अपने अभिनय से सजाएंगे।</p>
                                    <h4>Story & Screen-play: Bhupendra Vishnoi.</h4>
                                </div>
                            </div>
                        </div>
                        {/* end of div */}
                </div>
            </div>
        </section>
        <section id="about">
        <div className="about container">        
        <div className="aboutclass">
            <div className="div11">
                    <div className="about-img">
                           <img src={Image2} alt="img" style={{width: '60%', height: '50%'}} />
                    </div>

            </div>
            <div className="div12">
                <h2>Bhupendra Vishnoi</h2>
                <p> I was born in Kanth, a small town in Moradabad district of Uttar Pradesh. I have completed my education from Bangalore. I spent many years of my life in a small and my native village Sultanpur Khadder.</p>
                <p>Currently, I am living in Indore, the cleanest city of India. I have directed a short film 'zero' in 2017 along with many musical albums. I have directed more than fifteen wedding and three pre-wedding shoots.</p>
            </div>
            
        </div>
        <div><h1 className="section-title">About Me</h1></div>
        </div>
        </section>
        <section id="about">
        <div className="about container">        
        <div className="aboutclass">
            <div className="div12" style={{display: 'flex', flexDirection: 'column', width: '96%'}}>                
                    <input placeholder="Name please" onChange={(event)=>{setName(event.target.value)}} style={{margin: '4px', width: '240px'}} value={name} />
                    {/* <input placeholder="email?" onChange={(event)=>{setAddress(event.target.value)}} style={{margin: '4px', width: '240px'}} value={address}/> */}
                    <input type='number' placeholder="Mobile Number" onChange={(event)=>{setPhone(event.target.value)}} style={{margin: '4px', width: '240px'}} value={phone}/>
                     <textarea placeholder="feel free to write us..." onChange={(event)=>{setMessage(event.target.value)}} style={{margin: '4px', width: '90%', padding: '5px'}}  value={message}/>
                     <button onClick={saveMessage} style={{margin: '4px', width: '120px'}}>Send Message</button>
                     <p> {result}</p>
            </div>
            
            
        </div>
        <div><h1 className="section-title">Contact us</h1>
        <h1>Please write us to get in touch!</h1>
        </div>
        </div>
        </section>
    <section id="testimonial"> 
            <div className="testimonial container">
                <div><h1 className="section-title">Testimonials</h1></div>
                <div className="ucards">
                    <div className="ucard">
                        <p>This is a good concept for the new generation of writers. With new ideas and new concepts on a new platform. The digital world surely has opened up a lot of opportunities for everyone. I think filmy story is a good concept and will work.</p>
                        <p><h3>-Kiran Kumar</h3></p>
                    </div>
                    <div className="ucard">
                        <p>I am happy that something of this kind has come on the digital platform. I will now be able to guide my students. The art of screen writing is different from writing play and writing books. But whatever you do ultimately it should reach the people and I think filmystory is just the right platform.</p>
                        <p><h3>-Mohit Mishra</h3></p>
                    </div>
                
                


                </div>
            </div>
        </section>
        <section id="myfooter">
            {/* <Footer /> */}
            <div className="myfooter">
                <div className="brand"><h1><span> </span></h1></div>
                <h2>हम आपकी सेवा में सदैव तत्पर हैं!</h2>
                <div className="social-blank">
                    <div className="font-effect-emboss" style={{marginLeft: '12px', width: '9%', backgroundColor: 'rgb(104, 101, 101)', border: 'groove', textShadow: '-2px -4px 6px #ebe8e8'}}><p id="rm">Rachna Digi Films</p></div>
                    <h1 className="font-effect-fire" style={{marginLeft:'37px', textAlign: 'center', marginTop: '40px'}}>Our Gears</h1>
                    <div style={{width: '100vw', padding: '7px', marginLeft: '50px', textDecoration: 'none', lineHeight: '23px', textAlign: 'right', color: 'white', textShadow: '1px 2px 3px red'}}>
                    Sony Fx6 Camera<br/>
                    Sony a7iv Camera<br/>
                    Sony a7iii Camera<br/>
                    Sony a58 Camera<br/>
                    dji Drone Camera<br/>
                    Lighting Setup<br/>
                    Sound Recording<br/>
                    Make-up Room<br/>

                    </div>



                    
                </div>
                <div className="social-icons">
                    <div className="social-item"><a href="https://www.youtube.com/@rachnadigifilms8771" target="_blank" rel="noreferrer"><img src={Icon1} alt="ytube"/></a></div>
                    <div className="social-item"><a href="https://www.facebook.com/profile.php?id=100063798655828" target="_blank" rel="noreferrer"><img src={Icon2} alt="fb" /></a></div>
                    <div className="social-item"><a href="https://www.instagram.com/p/CA7mt39B82p/?igshid=MDJmNzVkMjY=" target="_blank" rel="noreferrer"><img src={Icon3} alt="insta" /></a></div>
                    <div className="social-item"><a href="https://twitter.com/DigiRachna?s=09" target="_blank" rel="noreferrer"><img src={Icon4} alt="twitt" /></a></div>
                    <div className="social-item"><a href="https://wa.me/917505157443" target="_blank" rel="noreferrer"><img src={Icon5} alt="wa" /></a></div>
                </div>
                <div className="address">
                <p>Address : 48-Patrakar Colony, Indore-452018</p>
                <p>Contact Number: (+91) 7505157443</p>
                </div>
                <div className="copyright">Copyright &#169; 2023 Rachna Digi Films. All rights are reserved.</div>


            </div>
            {/* <a href="https://www.youtube.com/@rachnadigifilms8771" target="_blank" rel="noreferrer">
            <button title="YouTube" style={{Color: 'white'}}>
            <FaYoutube color="red" style={{height: '20px', width: '30px'}} /></button></a> */}
        </section>
        </>
    );

    
}


export default Contents;